module.exports = __webpack_public_path__ + "media/images/flags/bh-ec61516daebfebe2cd499a46c9f6570a.svg";